const supports = [
  {
    icon: "ri-file-text-line",
    title: "稟議書のたたき台を提供",
    desc: "導入の目的、期待できる効果、コスト対効果までまとめた稟議書案を作成します。そのまま社内に提出できます。",
  },
  {
    icon: "ri-bar-chart-2-line",
    title: "比較表で「土俵」を変える",
    desc: "他社との『人件費』比較ではなく、『決まった成果を短期間で』という視点で評価できる資料を作成します。",
  },
  {
    icon: "ri-lock-line",
    title: "セキュリティ要件に対応",
    desc: "開発環境の分離、機密データの保護、NDAの締結、社内サーバー対応など、情報システム部門の要件に柔軟に対応します。",
  },
];

export default function SupportSection() {
  return (
    <section className="bg-gray-50 py-20">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-900 mb-3">稟議・社内調整もお手伝いします</h2>
          <p className="text-gray-500 text-sm">担当者様の事務負担をゼロに</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {supports.map((s) => (
            <div key={s.title} className="bg-white border border-gray-200 rounded-2xl p-7">
              <div className="w-12 h-12 flex items-center justify-center bg-blue-100 rounded-xl mb-4">
                <i className={`${s.icon} text-blue-600 text-2xl`}></i>
              </div>
              <h3 className="text-sm font-bold text-gray-900 mb-2">{s.title}</h3>
              <p className="text-xs text-gray-500 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}